import {useState} from 'react';
import Instance from '../../../../Helper/axios';
import {URL} from "../../../../Helper/baseURL";

export const useGetLeftOver = (onError) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);

    const fetch = async (page1,page2, status, dateFilters) => {
        setLoading(true);
        try{
            const result = await Instance.post(URL + `hub/HubStatus/getHubLeftOver//${localStorage.getItem('id')}/${page1}/${page2}`, {
                ...(dateFilters ?  {dateFilters} : {})
            })
            setData(result.data.result);
        }
        catch(error){
            onError(error);
        }
        finally {
            setLoading(false);
        }
    }

    return {loading, data, fetch};
}